import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=73b239f4&scoped=true&"
import script from "./EditService.vue?vue&type=script&lang=js&"
export * from "./EditService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b239f4",
  null
  
)

export default component.exports